import { render } from "./PriceInput.vue?vue&type=template&id=d42168d8&scoped=true"
import script from "./PriceInput.vue?vue&type=script&lang=js"
export * from "./PriceInput.vue?vue&type=script&lang=js"

import "./PriceInput.vue?vue&type=style&index=0&id=d42168d8&scoped=true&lang=scss"

import exportComponent from "/Users/giovannivignone/VSCodeProjects/mintSiteAMJ-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d42168d8"]])

export default __exports__